export default __webpack_public_path__ + "static/media/img-0153-india-premium-face.11603049.png";